/* Конструктор на сторінці Adaptis Amulet. 26.09.2026, за сценарієм власника.
   Перше питання: модифікувати свій Starlink чи купити новий з Amulet.
   - Свій Starlink: передзамовлення (вікно adaptis-request-popup). Конструктор
     на цьому закінчується.
   - Новий: модель. Mini, Mini X і Standard 4X відкривають звичайний конструктор
     сторінки цього Starlink (дані adaptis-cfg-*.js і рушій), але термінал у ньому
     це товар каталогу «Starlink з модифікацією Adaptis Amulet»: одна позиція в
     кошику. Для Performance конструктора немає: запит менеджеру.
   Сторінку не перезавантажуємо (власник): рушій запускаємо функцією
   window.AdaptisEngine і перезапускаємо з даними іншої моделі; вибір покупця
   (де користуватися, корпус, живлення) переносимо, якщо він є в новій моделі.
   Дані з секції: window.ADAPTIS_AMULET. */
(function(){
"use strict";
var A = window.ADAPTIS_AMULET;
if (!A) return;
window.ADAPTIS_ENGINE_MANUAL = true;
/* s14r (власник 30.09): на сторінці Amulet без вибору кількості для всіх моделей: у Mini і Mini X він з'являвся,
   у решти ні, і кнопка «Купити» та ціна стрибали при перемиканні моделі. */
(function(){ var st = document.createElement("style"); st.textContent = "#adaptisCfg .qty{display:none!important}"; document.head.appendChild(st); })();
var $ = function(id){ return document.getElementById(id); };
var money = function(c){ return (c / 100).toLocaleString("uk-UA").replace(/[, ]/g, " ") + " ₴"; };
var q = new URLSearchParams(location.search);

/* Моделі з конструктором: ключ, значення опції «модель» у каталозі, назва, опис. */
/* t: назва на картці, n: для заголовка й кошика. У конструкторі Amulet короткі
   назви, без «(офіційний імпорт)» (власник, 26.09.2026). */
var MODELS = [
  {k:"mini",  o:"Mini",        n:"Starlink Mini",        t:"Starlink Mini",        d:"Антена і Wi-Fi роутер в одному корпусі"},
  {k:"minix", o:"Mini X",      n:"Starlink Mini X",      t:"Starlink Mini X",      d:"Роутер окремо від антени"},
  {k:"x4",    o:"Standard 4X", n:"Starlink Standard 4X", t:"Starlink Standard 4X", d:"Для дому і великого навантаження"}
];
var PERF = {k:"perf", t:"Starlink Performance", d:"Комплект підбере менеджер"};
/* s14o (власник 30.09): Starlink V5 теж з Adaptis Amulet. V5 Kit продається під передзамовлення, тому як Performance:
   запит через вікно передзамовлення, ціна вгорі = V5 Kit + Amulet за призначенням. */
var V5 = {k:"v5", t:"Starlink V5", d:"Передзамовлення, строк погодить менеджер"};
var isReq = function(k){ return k === "perf" || k === "v5"; };
var GO_SVG = '<span class="spick__go" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 16L16 8M9 8h7v7"/></svg></span>';

var defense = q.get("mode") === "defense";
var sel = q.get("model") || "own";
if (["own", "new", "perf", "v5"].concat(MODELS.map(function(m){ return m.k; })).indexOf(sel) < 0) sel = "own";
var engine = false, engineLoaded = false, ENGINE_HTML = null;

var isDef = function(t){ return /оборон/i.test(t || ""); };
var svcVar = function(d){ return (A.svc.variants || []).filter(function(v){ return isDef(v.title) === d; })[0] || null; };
var kitVar = function(m, d){
  return (A.kit.variants || []).filter(function(v){ return v.o2 === m.o && isDef(v.o1) === d && v.available; })[0] || null;
};
/* Варіант без огляду на наявність: для ціни й «Повідомити про наявність». */
var anyVar = function(m, d){
  return (A.kit.variants || []).filter(function(v){ return v.o2 === m.o && isDef(v.o1) === d; })[0] || null;
};
/* 26.09.2026 (власник): моделі, яких немає в наявності, теж показуємо: замість
   конструктора кнопка «Повідомити про наявність». */
/* s13z8 (власник 30.09): ціна «термінал з Amulet» для моделі без наявності й Performance: ціна
   термінала в каталозі плюс Adaptis Amulet за призначенням (так само складені ціни набору). */
var realPrice = function(k, d){ var t = (A.terms || {})[k], s = svcVar(d); return t && s ? t + s.price : 0; };
var priceOf = function(m, d){ var r = realPrice(m.k, d); if (outOf(m) && r) return r; var v = anyVar(m, d); return v ? v.price : r; };
var models = function(){ return MODELS.filter(function(m){ return anyVar(m, defense); }); };
var outOf = function(m){ return !kitVar(m, defense); };
var modelOf = function(k){ return MODELS.filter(function(m){ return m.k === k; })[0] || null; };

function setUrl(extra){
  var u = new URLSearchParams(location.search);
  u.set("model", sel);
  if (defense) u.set("mode", "defense"); else u.delete("mode");
  Object.keys(extra || {}).forEach(function(k){ if (extra[k]) u.set(k, extra[k]); else u.delete(k); });
  history.replaceState(null, "", location.pathname + "?" + u.toString() + location.hash);
}

/* Картка вибору. З фото товару: div з роллю кнопки, фото веде на товар (↗). */
function card(x){
  var pic = x.img ? '<a class="card__img spick__im--ln" href="' + x.url + '" target="_blank" rel="noopener" title="Відкрити товар у новій вкладці" aria-label="Відкрити товар у новій вкладці"><img src="' + x.img + '" alt="" loading="lazy">' + GO_SVG + '</a>' : '';
  var inner = pic + '<span class="card__main"><span class="card__row"><span class="card__t"></span><span class="card__p">' + x.p + '</span></span><span class="card__d"></span></span>';
  return pic
    ? '<div role="button" tabindex="0" class="card-opt" data-amf="' + x.k + '" aria-pressed="' + x.on + '">' + inner + '</div>'
    : '<button type="button" class="card-opt" data-amf="' + x.k + '" aria-pressed="' + x.on + '">' + inner + '</button>';
}
function fill(host, list){
  host.innerHTML = list.map(card).join("");
  /* Тексти через textContent: у назвах і описах можуть бути лапки. */
  list.forEach(function(x, i){
    var b = host.children[i];
    b.querySelector(".card__t").textContent = x.t;
    b.querySelector(".card__d").textContent = x.d;
  });
}
var pic = function(k){ return (A.models || {})[k] || {}; };

function render(){
  var s = svcVar(defense), ms = models();
  var mins = ms.filter(function(m){ return !outOf(m); }).map(function(m){ return kitVar(m, defense).price; });
  var newOn = sel !== "own";
  fill($("amfQ1"), [
    {k:"own", on:!newOn, t:"Мій Starlink", p:s ? money(s.price) : "", d:"Ви надсилаєте нам будь-який термінал, ми встановлюємо Adaptis Amulet і повертаємо його вам"},
    {k:"new", on:newOn, t:"Новий Starlink з Adaptis Amulet", p:mins.length ? "від " + money(Math.min.apply(null, mins)) : "", d:"Термінал уже з модифікацією: обираєте модель, корпус, живлення і підписку"}
  ]);
  $("amfModels").hidden = !newOn;
  var perfP = realPrice("perf", defense), v5P = realPrice("v5", defense);
  var reqP = sel === "v5" ? v5P : perfP;
  /* s13z14 (власник 30.09): у картках без наявності «немає в наявності», у Performance «за запитом»;
     реальна ціна з Amulet лише вгорі, у підсумку (priceOf, perfP). */
  fill($("amfQ2"), ms.map(function(m){ return {k:m.k, on:sel === m.k, t:m.t, p:outOf(m) ? "немає в наявності" : money(kitVar(m, defense).price), d:m.d, img:pic(m.k).img, url:pic(m.k).url}; })
    /* s14r (власник 30.09): V5 одразу після Standard 4X, Performance останнім. */
    .concat(pic("v5").img ? [{k:V5.k, on:sel === "v5", t:V5.t, p:"передзамовлення", d:V5.d, img:pic("v5").img, url:pic("v5").url}] : [])
    .concat([{k:PERF.k, on:sel === "perf", t:PERF.t, p:"за запитом", d:PERF.d, img:pic("perf").img, url:pic("perf").url}]));
  $("amfEngine").hidden = !engine;
  var m = modelOf(sel);
  var h1 = document.querySelector("#adaptisCfg .buybox h1");
  /* Заголовок сторінки лишається «Adaptis Amulet» (власник): обрана модель видна в картках. */
  if (h1) h1.textContent = "Adaptis Amulet";
  if (engine) return;
  /* Без рушія ціну, кнопку й нижню панель веде цей скрипт. */
  var av = m ? anyVar(m, defense) : null;
  var price = sel === "own" ? (s ? money(s.price) : "") : isReq(sel) ? (reqP ? money(reqP) : "за запитом") : m ? (priceOf(m, defense) ? money(priceOf(m, defense)) : "") : mins.length ? "від " + money(Math.min.apply(null, mins)) : "";
  var btn = sel === "own" || sel === "v5" ? "Передзамовлення" : sel === "perf" ? "Надіслати запит" : m ? "Повідомити про наявність" : "Обрати модель";
  ["totVal", "barVal"].forEach(function(id){ if ($(id)) $(id).textContent = price; });
  ["buy", "buyBar"].forEach(function(id){ var b = $(id); if (b){ b.textContent = btn; b.disabled = false; b.classList.remove("buy--done"); } });
  ["totOld", "totOff"].forEach(function(id){ if ($(id)) $(id).hidden = true; });
  if ($("barCfg")) $("barCfg").textContent = sel === "own" ? "Adaptis Amulet для вашого Starlink" : sel === "perf" ? "Starlink Performance з Adaptis Amulet" : sel === "v5" ? "Starlink V5 з Adaptis Amulet" : m ? m.n + " з Adaptis Amulet" : "Starlink з Adaptis Amulet";
  /* Оплата частинами з тієї самої суми, що й у рушії: на 3, вгору до гривні. */
  var sum = sel === "own" ? (s ? s.price : 0) : isReq(sel) ? reqP : m ? priceOf(m, defense) : mins.length ? Math.min.apply(null, mins) : 0;
  var parts = sum > 0 ? "До 3 платежів, від " + money(Math.ceil(sum / 300) * 100) + " на місяць" : "До 3 платежів";
  document.querySelectorAll("[data-parts]").forEach(function(n){ n.textContent = parts; });
  /* Кількість має сенс лише для терміналів у кошик, не для передзамовлення. */
  document.querySelectorAll("#adaptisCfg .qty").forEach(function(n){ n.hidden = true; });
  toggle();
}

/* Перемикач «Ціна для Сил Оборони України», поки рушія немає; з рушієм його малює рушій. */
function toggle(){
  var host = $("priceMode");
  if (!host) return;
  host.innerHTML = "";
  /* s14r (власник 30.09): і для Performance діє ціна для Сил Оборони (Amulet за призначенням), перемикач лишається. */
  var w = document.createElement("label");
  w.className = "tgl";
  w.innerHTML = '<input type="checkbox" class="tgl__i"><span class="tgl__b"></span><span class="tgl__t"><b>Ціна для Сил Оборони України</b></span>';
  var i = w.querySelector("input");
  i.checked = defense;
  i.addEventListener("change", function(){
    defense = i.checked;
    var m = modelOf(sel);
    if (m && !outOf(m)) start(m); else { setUrl(); render(); }
  });
  host.appendChild(w);
}

function popup(title, variant){
  document.dispatchEvent(new CustomEvent("adaptis:request-product-open", {bubbles:true, detail:{
    productTitle:title, productId:A.svc.id, handle:A.svc.handle,
    variantId:variant ? variant.id : "", variantTitle:variant ? variant.title : ""}}));
}
function buy(e){
  if (engine) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  var m = modelOf(sel);
  if (sel === "own") popup(A.svc.title, svcVar(defense));
  else if (sel === "perf") popup("Starlink Performance з модифікацією Adaptis Amulet", null);
  else if (sel === "v5") popup("Starlink V5 з модифікацією Adaptis Amulet", svcVar(defense));
  else if (m){ var v = anyVar(m, defense); if (window.AdaptisNotify) window.AdaptisNotify.open(m.n + " з модифікацією Adaptis Amulet", "starlink-adaptis-amulet", v ? v.id : ""); }
  else { var box = $("amfModels"); if (box) box.scrollIntoView({behavior:"smooth", block:"center"}); }
}

/* Галерея, поки рушія немає: фото товару Amulet, стрілки, крапки, мініатюри.
   Рушій малює свою, тому перед його запуском цю прибираємо. */
var gal = null;
function galleryInit(){
  if (gal) return;
  var stage = document.querySelector("#adaptisCfg .gal__stage");
  var list = ((window.ADAPTIS_ASSETS || {}).media || []).filter(Boolean);
  if (!stage || !list.length) return;
  var src = function(f, w){ return "/cdn/shop/files/" + f + (f.indexOf("?") > -1 ? "&" : "?") + "width=" + w; };
  var track = document.createElement("div");
  track.className = "gal__track";
  list.forEach(function(f, i){
    var img = document.createElement("img");
    img.width = 900; img.height = 900; img.alt = ""; img.draggable = false; img.decoding = "async";
    if (i) img.loading = "lazy"; else img.addEventListener("load", function(){ track.classList.add("is-ready"); }, {once:true});
    img.src = src(f, 900);
    track.appendChild(img);
  });
  stage.insertBefore(track, stage.firstChild);
  var dots = $("galDots"), th = $("thumbs"), cur = 0;
  var box = document.querySelector("#adaptisCfg .gal");
  if (box) box.classList.toggle("gal--one", list.length < 2);
  var mark = function(){
    [].forEach.call(dots.children, function(d, i){ d.classList.toggle("is-on", i === cur); });
    [].forEach.call(th.children, function(t, i){ t.setAttribute("aria-pressed", String(i === cur)); });
  };
  var to = function(i){ cur = (i + list.length) % list.length; track.scrollTo({left:cur * track.getBoundingClientRect().width, behavior:"smooth"}); mark(); };
  dots.innerHTML = ""; th.innerHTML = "";
  list.forEach(function(f, i){
    var d = document.createElement("button"); d.type = "button"; d.className = "gdot"; d.setAttribute("aria-label", "Фото " + (i + 1));
    d.addEventListener("click", function(){ to(i); }); dots.appendChild(d);
    var t = document.createElement("button"); t.type = "button"; t.className = "gth"; t.setAttribute("aria-pressed", "false");
    t.innerHTML = '<img src="' + src(f, 200) + '" alt="" loading="lazy">';
    t.addEventListener("click", function(){ to(i); }); th.appendChild(t);
  });
  var tm = 0;
  track.addEventListener("scroll", function(){ clearTimeout(tm); tm = setTimeout(function(){
    var i = Math.round(track.scrollLeft / Math.max(1, track.getBoundingClientRect().width));
    if (i !== cur){ cur = i; mark(); } }, 90); }, {passive:true});
  if ($("galPrev")) $("galPrev").addEventListener("click", function(){ to(cur - 1); });
  if ($("galNext")) $("galNext").addEventListener("click", function(){ to(cur + 1); });
  gal = {track:track};
  mark();
}

/* Скидання каркаса перед новим запуском рушія або поверненням до «Мій Starlink»:
   кнопки й блоки замінюємо копіями без обробників, обробники попереднього
   запуску на window вимикає лічильник запусків (live() у рушії). */
function resetDom(){
  window.__adxGen = (window.__adxGen || 0) + 1;
  gal = null;
  if (ENGINE_HTML !== null) $("amfEngine").innerHTML = ENGINE_HTML;
  ["buy", "buyBar", "buyNow", "galPrev", "galNext"].forEach(function(id){ var e = $(id); if (e) e.replaceWith(e.cloneNode(true)); });
  document.querySelectorAll("#adaptisCfg [data-qd]").forEach(function(b){ b.replaceWith(b.cloneNode(true)); });
  ["priceMode", "colorTop"].forEach(function(id){ if ($(id)) $(id).innerHTML = ""; });
  /* s13z (власник 30.09): галерея блимала. Рушій ховає нову стрічку фото, доки не завантажиться
     перше (is-ready), а стару ми прибирали одразу. Тепер стара лежить поверх, доки нова не готова;
     крапки й мініатюри рушій перемальовує сам. */
  var st = document.querySelector("#adaptisCfg .gal__stage");
  if (st && getComputedStyle(st).position === "static") st.style.position = "relative";
  document.querySelectorAll("#adaptisCfg .gal__track").forEach(function(t){
    if (t.classList.contains("gal__track--old")){ t.remove(); return; }
    t.classList.add("gal__track--old");
    t.style.position = "absolute"; t.style.inset = "0"; t.style.zIndex = "3"; t.style.pointerEvents = "none";
    var sl = t.scrollLeft;
    var drop = function(){ if (t.parentNode) t.remove(); };
    var mo = new MutationObserver(function(){
      var n = document.querySelector("#adaptisCfg .gal__track:not(.gal__track--old)");
      if (n && n.classList.contains("is-ready")){ mo.disconnect(); setTimeout(drop, 120); }
    });
    if (st) mo.observe(st, {subtree:true, attributes:true, attributeFilter:["class"], childList:true});
    setTimeout(function(){ mo.disconnect(); drop(); }, 2500);
    requestAnimationFrame(function(){ t.scrollLeft = sl; });
  });
}

/* Дані сторінки термінала, але термінал це товар «Starlink з модифікацією
   Adaptis Amulet»: варіант і ціна за моделлю й призначенням. Крок Amulet
   не показуємо, модифікація вже в терміналі. */
function overlay(m){
  var P = window.ADAPTIS_CONFIG;
  if (!P) return;
  var T = P.TERMINAL || {};
  var d = function(){ var X = window.ADX; return !!(X && X.state && X.state.purpose === "defense"); };
  var v = function(){ return kitVar(m, d()) || kitVar(m, !d()); };
  P.TERMINAL = {
    title:m.n + " з модифікацією Adaptis Amulet", short:m.n + " з Adaptis Amulet",
    img:A.kit.img || T.img,
    get variant(){ var x = v(); return x ? x.id : T.variant; },
    get price(){ var x = v(); return x ? x.price : T.price; }
  };
  (P.CONFIG.steps || []).forEach(function(s){ if (s.handle === "amulet"){ s.when = function(){ return false; }; s.def = null; } });
  P.AMULET = true;
}
function load(src){
  return new Promise(function(res, rej){
    var s = document.createElement("script");
    s.src = src; s.onload = res; s.onerror = rej;
    document.body.appendChild(s);
  });
}
/* Вибір, зроблений у попередній моделі, переходить у нову через адресу
   (?sp= рушія): рушій бере з неї лише те, що є в новій моделі. */
function carry(){
  var X = window.ADX;
  if (!X || !X.sp) return {};
  var sp = X.sp;
  return {sp:[sp.corpus, sp.power, sp.auto, sp.where, sp.home, sp.mount, sp.roof, sp.homeMount, sp.homeCorpus].map(function(v){ return v == null ? "" : v; }).join(".")};
}
/* 29.09.2026 (власник, s13v): при зміні моделі сторінка стрибала. resetDom очищає галерею
   (мініатюри, крапки) і конструктор, а рушій малює їх заново лише після завантаження даних
   моделі: сторінка на мить коротшала, і картка під пальцем їхала. Тримаємо висоту галереї й
   конструктора, поки рушій не намалює нове, і повертаємо натиснуту картку на те саме місце. */
function keep(k){
  var a = document.querySelector('[data-amf="' + k + '"]');
  if (!a) return function(){};
  var top0 = a.getBoundingClientRect().top;
  var hold = [document.querySelector("#adaptisCfg .gal"), $("amfEngine"), $("priceMode"), $("colorTop")].filter(Boolean);
  hold.forEach(function(n){ n.style.minHeight = n.offsetHeight + "px"; });
  var fix = function(){
    var b = document.querySelector('[data-amf="' + k + '"]');
    if (!b) return;
    var d = b.getBoundingClientRect().top - top0;
    if (Math.abs(d) > 1) window.scrollBy({top:d, left:0, behavior:"instant"});
  };
  /* Утримуємо картку на місці кожен кадр 1,5 с: нові блоки з'являються не разом. Людина
     почала гортати сама: відпускаємо. */
  var until = Date.now() + 1500, off = false;
  var quit = function(){ off = true; };
  ["touchstart", "wheel", "keydown"].forEach(function(ev){ window.addEventListener(ev, quit, {once:true, passive:true}); });
  (function loop(){ if (off || Date.now() > until) return; fix(); requestAnimationFrame(loop); })();
  return function(){
    requestAnimationFrame(fix);
    setTimeout(function(){ hold.forEach(function(n){ n.style.minHeight = ""; }); fix(); }, 700);
  };
}
function start(m){
  var done = keep(m.k);
  var extra = engine ? carry() : {};
  if (engine && window.ADX && window.ADX.state) defense = window.ADX.state.purpose === "defense";
  if (engine || gal) resetDom();
  engine = true;
  sel = m.k;
  setUrl(extra);
  document.querySelectorAll("#adaptisCfg .qty").forEach(function(n){ n.hidden = false; });
  render();
  load(A.cfg[m.k]).then(function(){
    overlay(m);
    if (engineLoaded) return;
    engineLoaded = true;
    return load(A.engine);
  }).then(function(){ if (window.AdaptisEngine) window.AdaptisEngine(); done(); })
    .catch(function(){ engine = false; sel = "new"; resetDom(); setUrl(); galleryInit(); render(); done(); });
}
function stop(k){
  var done = keep(k);
  if (window.ADX && window.ADX.state) defense = window.ADX.state.purpose === "defense";
  resetDom();
  engine = false;
  sel = k;
  setUrl({sp:""});
  galleryInit();
  render();
  done();
}

document.addEventListener("click", function(e){
  var b = e.target.closest && e.target.closest("[data-amf]");
  /* 26.09.2026 (власник): клік по фото обирає модель, а не відкриває сторінку;
     на товар веде лише значок ↗. */
  if (b && e.target.closest(".spick__go")) return;
  if (b && e.target.closest(".spick__im--ln")) e.preventDefault();
  if (b){
    var k = b.getAttribute("data-amf");
    if (k === "new" && sel !== "own") return;
    if (k === sel) return;
    var m = modelOf(k);
    if (m && !outOf(m)) start(m);
    else if (engine) stop(k);
    else { sel = k; setUrl(); render(); }
    return;
  }
  var bb = e.target.closest && e.target.closest("#buy, #buyBar");
  if (bb) buy(e);
}, true);
document.addEventListener("keydown", function(e){
  var b = e.target.closest && e.target.closest("div[data-amf]");
  if (b && (e.key === "Enter" || e.key === " ") && e.target === b){ e.preventDefault(); b.click(); }
});

function boot(){
  if (!$("amfQ1")) return;
  ENGINE_HTML = $("amfEngine").innerHTML;
  var m = modelOf(sel);
  if (m && !outOf(m)) start(m);
  else { galleryInit(); render(); }
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
